export default "__VITE_ASSET__YrPuQ798__"